var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _Config = class {
  constructor(config = {}) {
    __publicField(this, "config");
    this.config = {
      ..._Config.defaultConfig,
      ...config
    };
  }
  getValue(name) {
    return this.config[name];
  }
  setValue(name, value) {
    this.config[name] = value;
    return this;
  }
};
let Config = _Config;
__publicField(Config, "defaultConfig", {
  beforePersistSettleLimit: 20,
  beforeUpdateSettleLimit: 20,
  persistSuccessSettleLimit: 20
});
export {
  Config
};
//# sourceMappingURL=Config.js.map
